import { ExtraOptions } from "@angular/router";

export const RouteExtraOptions: ExtraOptions = {
  onSameUrlNavigation: "reload",
  paramsInheritanceStrategy: "emptyOnly",
  initialNavigation: "disabled"
};
